export default {
  findMetricKeyInRentSurvey(comparable, key) {
    if (comparable && comparable.RentSurveyList && comparable.RentSurveyList[0] && comparable.RentSurveyList[0][key]) {
      return comparable.RentSurveyList[0][key];
    }

    return null;
  },
};
